/**
 * Blog Listing — sequential multi-line title underline animation.
 *
 * Pure CSS cannot animate an underline sequentially across line 1 then line 2
 * because CSS has no awareness of where text wraps. This script uses
 * getClientRects() on the inline <a> element, which returns one DOMRect per
 * line box, to build one absolutely-positioned underline span per line.
 * Each span uses transform: scaleX(0 → 1) with a staggered transition-delay
 * so line 1 sweeps left → right first, then line 2 follows.
 *
 * DOM structure after init:
 *   <span class="blog-listing__card-title-wrap">   ← injected wrapper (position: relative)
 *     <a class="blog-listing__card-title">...</a>
 *     <span class="blog-listing__card-title-line">  ← one per line, absolutely placed
 *     <span class="blog-listing__card-title-line">
 *   </span>
 */

document.addEventListener("DOMContentLoaded", () => {
  const LINE_DURATION = 0.32; // seconds per line sweep
  const LINE_EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)";
  const UNDERLINE_OFFSET = 3; // px below the bottom of each line box

  const blocks = document.querySelectorAll(".blog-listing");
  if (!blocks.length) return;

  const titles = document.querySelectorAll(".blog-listing__card-title");

  titles.forEach((title) => {
    // Wrap the <a> in a block-level span so we have a position: relative
    // containing block for the absolutely-positioned underline spans.
    const wrap = document.createElement("span");
    wrap.className = "blog-listing__card-title-wrap";
    title.parentNode.insertBefore(wrap, title);
    wrap.appendChild(title);

    let lineSpans = [];

    const buildLines = () => {
      // Remove old underline spans.
      lineSpans.forEach((s) => s.remove());
      lineSpans = [];

      const titleRects = Array.from(title.getClientRects());
      const wrapRect = wrap.getBoundingClientRect();

      titleRects.forEach((rect, i) => {
        const span = document.createElement("span");
        span.className = "blog-listing__card-title-line";
        span.style.left = `${rect.left - wrapRect.left}px`;
        span.style.top = `${rect.bottom - wrapRect.top - UNDERLINE_OFFSET}px`;
        span.style.width = `${rect.width}px`;
        // Transition: each line has its own delay so they run sequentially.
        span.style.transition = `transform ${LINE_DURATION}s ${LINE_EASE} ${
          i * LINE_DURATION
        }s`;
        wrap.appendChild(span);
        lineSpans.push(span);
      });
    };

    buildLines();

    // Rebuild on resize (debounced) in case line breaks change.
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildLines, 120);
    });

    // Hover — animate in forward order: line 1 first, line 2 after.
    title.addEventListener("mouseenter", () => {
      lineSpans.forEach((span, i) => {
        span.style.transition = `transform ${LINE_DURATION}s ${LINE_EASE} ${i * LINE_DURATION}s`;
        span.style.transform = "scaleX(1)";
      });
    });

    // Unhover — animate out in reverse order: line 2 retracts first, then line 1.
    title.addEventListener("mouseleave", () => {
      const total = lineSpans.length;
      lineSpans.forEach((span, i) => {
        const reverseDelay = (total - 1 - i) * LINE_DURATION;
        span.style.transition = `transform ${LINE_DURATION}s ${LINE_EASE} ${reverseDelay}s`;
        span.style.transform = "scaleX(0)";
      });
    });
  });
});
